import { render, staticRenderFns } from "./Datadownload.vue?vue&type=template&id=02ae3dab&scoped=true&"
import script from "./Datadownload.vue?vue&type=script&lang=js&"
export * from "./Datadownload.vue?vue&type=script&lang=js&"
import style0 from "./Datadownload.vue?vue&type=style&index=0&id=02ae3dab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ae3dab",
  null
  
)

export default component.exports